import { useMutation, useQueryClient } from '@tanstack/react-query'
import { sessionService } from '../api/sessionService'
import { WAR_ROOM_QUERY_KEYS } from '../api/queryClient'
import { getWarRoomErrorCode } from '../api/warRoomClient'

export function useStartSession(sessionId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => sessionService.start(sessionId),
    onSuccess: (response) => {
      // Update cache immediately from response
      qc.setQueryData(
        WAR_ROOM_QUERY_KEYS.session(sessionId),
        response.data
      )
    },
    onError: (err) => {
      const code = getWarRoomErrorCode(err)
      console.error('[WarRoom] start session failed', code)
    },
  })
}

export function usePauseSession(sessionId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => sessionService.pause(sessionId),
    onSuccess: (response) => {
      qc.setQueryData(WAR_ROOM_QUERY_KEYS.session(sessionId), response.data)
    },
    onError: (err) => {
      const code = getWarRoomErrorCode(err)
      console.error('[WarRoom] pause session failed', code)
    },
  })
}

export function useCompleteSession(sessionId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => sessionService.complete(sessionId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WAR_ROOM_QUERY_KEYS.session(sessionId) })
    },
    onError: (err) => {
      const code = getWarRoomErrorCode(err)
      console.error('[WarRoom] complete session failed', code)
    },
  })
}

export function useCreateSession() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: sessionService.create,
    onSuccess: () => {
      // Invalidate sessions list to show new entry
      qc.invalidateQueries({ queryKey: ['war-room', 'sessions'] })
    },
    onError: (err) => {
      const code = getWarRoomErrorCode(err)
      console.error('[WarRoom] create session failed', code)
    },
  })
}

export function useMarkSessionReady(sessionId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => sessionService.markReady(sessionId),
    onSuccess: (response) => {
      qc.setQueryData(WAR_ROOM_QUERY_KEYS.session(sessionId), response.data)
    },
    onError: (err) => {
      const code = getWarRoomErrorCode(err)
      console.error('[WarRoom] mark session ready failed', code)
    },
  })
}
